import { isElectron } from './isElectron';

export function appUrl(path = '/') {
  return new URL(path, isElectron() ? process.env.REACT_APP_BASE_URL : window.location.origin);
}
